import {
    Datagrid,
    EditButton,
    List,
    Show,
    SimpleShowLayout,
    TextField,
    Pagination,
    DateField,
    BooleanField,
    ArrayField,
    SingleFieldList,
    ChipField,
} from "react-admin";
import { TextInput } from "react-admin";
import { VisibilityBulkActionButtons } from "./common";
import { ShortDateField } from "./customFields";

const filters = [<TextInput source="q" label="Search" alwaysOn />];

export const UserList = () => (
    <List
        filters={filters}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100, 200]} />}
        sort={{ field: "created_at", order: "DESC" }}
    >
        <Datagrid rowClick="show" bulkActionButtons={<VisibilityBulkActionButtons />}>
            <TextField source="email" />
            <TextField source="id" />
            <ShortDateField source="created_at" label="Created at" />
            <ShortDateField source="last_app_start" />
            <EditButton />
        </Datagrid>
    </List>
);

export const UserShow = () => (
    <Show>
        <SimpleShowLayout>
            <h2>User Details</h2>
            <TextField source="email" />
            <TextField source="id" />
            <TextField source="firebase_id" />
            <DateField source="created_at" label="Created at" />
            <BooleanField source="is_email_verified" />
            <ArrayField source="entitlements" label="Entitlements">
                <SingleFieldList linkType={false}>
                    <ChipField source="name" size="small" />
                </SingleFieldList>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
